module.exports = __webpack_public_path__ + "img/ContrarianView.8e7b93b9.png";